<template lang="html">
  <div>
    <v-form
      ref="positionApprovalLevelCreationForm"
      class="overflow"
      data-simplebar
    >
      <v-data-iterator
        :items="positions"
        :hide-default-footer="true"
        disable-pagination
        item-key="id"
      >
        <template>
          <v-row>
            <v-col
              v-for="(position,index) in positions"
              :key="index"
              cols="12"
              md="6"
            >
              <v-card class="mx-4">
                <v-card-title style="padding-top:0;padding-bottom:0;margin:0">
                  <span
                    :title="position.name"
                    class=" text-truncate title v-label theme--light pt-3"
                  >Position: {{ position.name }}</span>
                </v-card-title>

                <v-divider />
                <v-list
                  dense
                >
                  <v-list-item
                    class=""
                  >
                    <v-list-item-content
                      class="py-0"
                    >
                      Approval Level:
                    </v-list-item-content>
                    <v-text-field
                      v-model="position.level"
                      :rules="[rules.required,rules.min,rules.max]"
                      max="2"
                      min="1"
                      dense
                      class="centered-input"
                      type="number"
                    />
                  </v-list-item>
                </v-list>
              </v-card>
            </v-col>
          </v-row>
        </template>
      </v-data-iterator>
    </v-form>

    <v-container>
      <hr>
      <v-card-actions>
        <v-spacer />
        <v-btn
          class="mx-5"
          text
          @click="goPrevious"
        >
          Go back
        </v-btn>
        <v-btn
          color="success"          
          @click="goNext"
        >
          Proceed
        </v-btn>
      </v-card-actions>
    </v-container>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        loading: false,
        positions: [],    
        rules: {
          required: value => !!value || 'Required.',     
          min: value => value >= 1 || 'Minimum number is 1',      
          max: value => value <= 2 || 'Max number is 2',      
        },  

      }
    },
    created () {
      this.loading = true
      this.loadData()
    },
    methods: {
      loadData () {
        this.$http.all([
          this.$api.positions().list(),
        ])
          .then(this.$http.spread((positions) => {
            this.positions = positions.data.map((position) => {
              return {
                id: position.id,
                name: position.name,
                level: 1,
              }
            })

            this.loading = false
          }))
      },
      goNext () {
        if (this.$refs.positionApprovalLevelCreationForm.validate()) {
          this.$emit('next-step')
        }
      },
      goPrevious () {
        this.$emit('previous-step')
      },
      getFormData () {
        return this.positions.map((position) => {
          return {
            id: position.id,
            level: position.level,
          }
        })
      },
      
    },
  }
</script>

<style lang='css' scoped>
  ::v-deep .centered-input input {
    text-align: center
  }

  .overflow {
    height:50vh;
    overflow-x:hidden;
  }
</style>
